const CLASSIC_UI_PARAM = 'ui';
const CLASSIC_UI_VALUE = 'classic';
const EXTERNAL_URL_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

export const isClassicUiSearch = (search: string) => {
  const params = new URLSearchParams(search);
  return params.get(CLASSIC_UI_PARAM) === CLASSIC_UI_VALUE;
};

export const appendClassicUiParam = (to: string) => {
  if (EXTERNAL_URL_PATTERN.test(to)) {
    return to;
  }

  const hashIndex = to.indexOf('#');
  const pathWithSearch = hashIndex >= 0 ? to.slice(0, hashIndex) : to;
  const hash = hashIndex >= 0 ? to.slice(hashIndex) : '';
  const searchIndex = pathWithSearch.indexOf('?');
  const pathname = searchIndex >= 0 ? pathWithSearch.slice(0, searchIndex) : pathWithSearch;
  const search = searchIndex >= 0 ? pathWithSearch.slice(searchIndex + 1) : '';
  const params = new URLSearchParams(search);

  params.set(CLASSIC_UI_PARAM, CLASSIC_UI_VALUE);

  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}${hash}`;
};

export const preserveClassicUiParam = (to: string, currentSearch: string) => {
  return isClassicUiSearch(currentSearch) ? appendClassicUiParam(to) : to;
};
